import htmx from "htmx.org";
import topbar from "topbar";
import "htmx-ext-sse";
import "htmx-ext-remove-me";
import "idiomorph";
import "idiomorph/htmx";
import {SCRAYE_ORANGE} from "../../../theme/colors";

htmx.config.selfRequestsOnly = false;
htmx.config.withCredentials = true;

type HtmxEventDetail = {
  elt: Element;
  xhr: XMLHttpRequest;
};

const getHtmxEventDetail = (evt: Event) => (evt as CustomEvent<HtmxEventDetail>).detail;

htmx.defineExtension("disable-element", {
  // @ts-expect-error htmx extension event is not typed by htmx.org
  onEvent: function (name, evt) {
    // @ts-expect-error htmx extension event is not typed by htmx.org
    const elt = evt.detail.elt;
    if (name !== "htmx:beforeRequest" && name !== "htmx:afterRequest") {
      return;
    }

    const target = elt.getAttribute("hx-disable-element");
    if (!target) {
      console.warn("No target found for hx-disable-element", elt);
      return;
    }

    const targetElements =
      target === "self"
        ? [elt]
        : target === "form"
          ? elt.querySelectorAll("input, button, select, textarea")
          : document.querySelectorAll(target);
    if (targetElements.length === 0) {
      console.warn("No target elements found for hx-disable-element", target, elt);
      return;
    }

    for (const targetElement of targetElements) {
      if (name === "htmx:beforeRequest" && targetElement) {
        targetElement.disabled = true;
      } else if (name === "htmx:afterRequest" && targetElement) {
        targetElement.disabled = false;
      }
    }
  },
});

document.body.addEventListener("htmx:responseError", function (evt) {
  const {xhr} = getHtmxEventDetail(evt);
  window.alert(`Error: ${xhr.responseText}`);
});

document.body.addEventListener("htmx:beforeRequest", function (evt) {
  const {elt} = getHtmxEventDetail(evt);
  if (elt.closest("[data-no-topbar]")) {
    return;
  }
  topbar.config({barColors: {"0": SCRAYE_ORANGE}});
  topbar.show();
});

document.body.addEventListener("htmx:afterRequest", function (evt) {
  const {elt} = getHtmxEventDetail(evt);
  if (elt.closest("[data-no-topbar]")) {
    return;
  }
  topbar.hide();
});
document.body.addEventListener("htmx:sseOpen", (evt) => {
  const {source} = (evt as CustomEvent<{source: EventSource}>).detail;
  source.addEventListener("sse-auth-error", () => window.location.reload(), {once: true});
});

// @ts-expect-error htmx is exposed for inline handlers and debugging.
window.htmx = htmx;

export default htmx;
